import { CategoryType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

export const getCategories = async () => {
  return axios
    .get(ServiceEndpoints.CATEGORY)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const createCategory = async (data: {
  name: string;
  description?: string;
}) => {
  return axios
    .post(ServiceEndpoints.CATEGORY, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const updateCategory = async (id: string, data: CategoryType) => {
  const { ...categoryData } = data;

  // Send a PUT request to the API endpoint to update the category
  return axios
    .put(`${ServiceEndpoints.CATEGORY}/${id}`, categoryData)
    .then(({ data }) => {
      // Return the response data upon a successful update
      return Promise.resolve(data);
    })
    .catch((err) => {
      // Handle errors by rejecting the promise
      return Promise.reject(err);
    });
};

export const getCategoryById = async (id: string) => {
  return axios
    .get(ServiceEndpoints.CATEGORY + "/" + id)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const deleteCategory = async (id: string) => {
  return axios
    .delete(ServiceEndpoints.CATEGORY + "/" + id)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
